// Browser-compatible Google Sheets integration using Google Apps Script
class GoogleSheetsService {
  constructor() {
    this.scriptURL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;
    this.isConfigured = !!this.scriptURL;
    
    if (!this.isConfigured) {
      console.warn('Google Apps Script URL not configured. Google Sheets integration will be disabled.');
    }
  }

  async appendInquiry(inquiryData) {
    if (!this.isConfigured) {
      console.warn('Google Apps Script not configured, skipping spreadsheet update');
      return { success: false, error: 'Google Apps Script not configured' };
    }

    try {
      // Format the data for the spreadsheet
      const formData = {
        timestamp: new Date().toLocaleString('en-IN', { 
          timeZone: 'Asia/Kolkata',
          dateStyle: 'medium',
          timeStyle: 'short'
        }),
        name: inquiryData.from_name || '',
        email: inquiryData.from_email || '',
        phone: inquiryData.phone_number || '',
        company: inquiryData.company_name || '',
        service: inquiryData.service_interest || '',
        message: inquiryData.message || '',
        status: 'New'
      };

      // Send as FormData with no-cors to avoid preflight and CORS errors
      // Apps Script will read fields via e.parameter.
      const fd = new FormData();
      Object.entries(formData).forEach(([key, value]) => fd.append(key, value));

      await fetch(this.scriptURL, {
        method: 'POST',
        mode: 'no-cors',
        body: fd,
      });

      // With no-cors, the response is opaque and cannot be read.
      // Treat this as a fire-and-forget write; rely on Sheet content to verify.
      console.log('Posted inquiry to Google Apps Script (opaque response due to no-cors)');
      return { success: true };
    } catch (error) {
      console.error('Error appending to Google Sheets:', error);
      
      // Provide more specific error messages for common issues
      if (error.message.includes('CORS') || error.message.includes('fetch')) {
        return { 
          success: false, 
          error: 'CORS error: Please ensure your Google Apps Script has proper CORS headers configured. See GOOGLE_SHEETS_SETUP.md for updated script.' 
        };
      }
      
      return { success: false, error: error.message };
    }
  }

  async getInquiries() {
    // For now, we'll return the localStorage data since we can't directly read from Google Sheets in browser
    try {
      const inquiries = JSON.parse(localStorage.getItem('inquiries') || '[]');
      return { success: true, data: inquiries };
    } catch (error) {
      console.error('Error fetching inquiries:', error);
      return { success: false, error: error.message };
    }
  }
}

const googleSheetsService = new GoogleSheetsService();
export default googleSheetsService;